import { render, staticRenderFns } from "./linkPermissionDialog.vue?vue&type=template&id=6acd3750&"
import script from "./linkPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./linkPermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports